import { openModal } from '@mantine/modals';
import { MODAL_SIZE_DEFAULT } from '@shared/ui/modal';
import type { CandidateReview } from '@entities/candidateReview';
import type { CompanyReview } from '@entities/companyReview';
import dayjs from 'dayjs';
import { CandidateReviewDetailModalContent } from './CandidateReviewDetailModalContent';
import { CompanyReviewDetailModalContent } from './CompanyReviewDetailModalContent';

const CANDIDATE_MODAL_ID = 'candidate-review-detail';
const COMPANY_MODAL_ID = 'company-review-detail';

const formatReviewDate = (reviewAt: string | null) =>
  reviewAt ? dayjs(reviewAt).format('DD.MM.YYYY, HH:mm') : '-';

export const useReviewDetailModal = () => {
  const openCandidateReviewDetailModal = (review: CandidateReview) => {
    openModal({
      modalId: CANDIDATE_MODAL_ID,
      title: `Отзыв компании от ${formatReviewDate(review.reviewAt)}`,
      centered: true,
      size: MODAL_SIZE_DEFAULT,
      radius: 16,
      children: <CandidateReviewDetailModalContent review={review} />,
    });
  };

  const openCompanyReviewDetailModal = (review: CompanyReview) => {
    openModal({
      modalId: COMPANY_MODAL_ID,
      title: `Отзыв кандидата от ${formatReviewDate(review.reviewAt)}`,
      centered: true,
      size: MODAL_SIZE_DEFAULT,
      radius: 16,
      children: <CompanyReviewDetailModalContent review={review} />,
    });
  };

  return {
    openCandidateReviewDetailModal,
    openCompanyReviewDetailModal,
  };
};
